import { BehaviorSubject, Observable } from 'rxjs';

import { OverlayAnimationStateEnum } from '../enums/overlay-animation.enum';
import { FullProfileDialogAnimationsEnum } from '../enums/full-profile-dialog-animations.enum';

export class FullProfileAnimationModel {
    animation: FullProfileDialogAnimationsEnum;
    animationState: OverlayAnimationStateEnum;

    constructor(animation: FullProfileDialogAnimationsEnum, animationState: OverlayAnimationStateEnum) {
        this.animation = animation;
        this.animationState = animationState;
    }
}

/** An animation trigger for a take-over/slide-in panel opening, ready to pass as its `animationTrigger` input */
export function buildSlideInAnimationTrigger(): Observable<FullProfileAnimationModel> {
    return new BehaviorSubject(
        new FullProfileAnimationModel(FullProfileDialogAnimationsEnum.slideInOutAnimation, OverlayAnimationStateEnum.open)
    );
}
